<template>
    <LayoutSub>
        <SubSection classList="pb-0" v-if="data">
            <ListNormalPage :data="data" />
            <div class="noti_box">
                <p>
                    본 정보는 오류가 나거나 지연될 수 있습니다. <br />
                    제공된 정보에 의한 투자결과에 대한 법적인 책임을 지지않습니다.
                </p>
            </div>
        </SubSection>
        <LoadingWrap v-else />
    </LayoutSub>
</template>

<script>
import { getFssData } from '@/api';
import LoadingWrap from '@/components/LoadingWrap.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import ListNormalPage from '@/views/common/ListNormalPage.vue';

export default {
    components: {
        SubSection,
        LayoutSub,
        ListNormalPage,
        LoadingWrap,
    },
    data() {
        return {
            data: null,
        };
    },
    async mounted() {
        this.getList();
    },
    methods: {
        async getList() {
            try {
                const {
                    data: { paging: data },
                } = await getFssData(this.$route.query);
                this.data = {
                    ...data,
                    list: data.list.map((el) => {
                        return {
                            ...el,
                            subject: el.report_nm,
                            writer: el.flr_nm,
                            writeDate: `${el.rcept_dt.slice(0, 4)}-${el.rcept_dt.slice(4, 6)}-${el.rcept_dt.slice(6, 8)}`,
                        };
                    }),
                    fss: true,
                    noWriter: true,
                };
            } catch (err) {
                if (!this.data) this.data = null;
            }
        },
    },
    watch: {
        async $route() {
            await this.getList();
        },
    },
};
</script>

<style lang="scss" scoped>
.noti_box {
    margin-top: 30px;
    border: 3px solid #fafafa;
    color: #999;
    padding: 20px 30px;

    p {
        font-size: 16px;
        line-height: 1.8;
    }
}
</style>
